import { useRouter } from 'next/router';
import { ReactNode, useEffect } from 'react';
import { EVENT_NAMES, sendEvent } from '../../../utils/analytics';
import { AuthProvider, useAuth } from '../../../utils/authContext';

export type Options = {
  allowUnauthenticated?: boolean;
  skipRedirect?: boolean;
};

type Props = Options & {
  children: ReactNode;
};
const AuthenticatedLayout = ({ skipRedirect, allowUnauthenticated, children }: Props) => {
  const router = useRouter();
  const { isUnauthenticated, isUnverified } = useAuth();
  const shouldRedirect =
    !skipRedirect && ((!allowUnauthenticated && isUnauthenticated) || isUnverified);

  useEffect(() => {
    if (shouldRedirect) {
      sendEvent({
        name: EVENT_NAMES.navigation,
        properties: {
          'from path': window.location.pathname,
          'from query': window.location.search,
          to: '/login',
        },
      });
      router.push(`/login?returnUrl=${encodeURIComponent(location.pathname + location.search)}`);
    }
  }, [shouldRedirect, router]);

  return <>{children}</>;
};

export default function AuthenticatedLayoutProvider(props: Props) {
  return (
    <AuthProvider>
      <AuthenticatedLayout {...props} />
    </AuthProvider>
  );
}
